/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliveryCalculationMemberGradeRespVo } from './DeliveryCalculationMemberGradeRespVo';
import {
    DeliveryCalculationMemberGradeRespVoFromJSON,
    DeliveryCalculationMemberGradeRespVoFromJSONTyped,
    DeliveryCalculationMemberGradeRespVoToJSON,
    DeliveryCalculationMemberGradeRespVoToJSONTyped,
} from './DeliveryCalculationMemberGradeRespVo';
import type { DeliveryCalculationAdditionalServiceRespVo } from './DeliveryCalculationAdditionalServiceRespVo';
import {
    DeliveryCalculationAdditionalServiceRespVoFromJSON,
    DeliveryCalculationAdditionalServiceRespVoFromJSONTyped,
    DeliveryCalculationAdditionalServiceRespVoToJSON,
    DeliveryCalculationAdditionalServiceRespVoToJSONTyped,
} from './DeliveryCalculationAdditionalServiceRespVo';
import type { WarehouseTransportMethodsDto } from './WarehouseTransportMethodsDto';
import {
    WarehouseTransportMethodsDtoFromJSON,
    WarehouseTransportMethodsDtoFromJSONTyped,
    WarehouseTransportMethodsDtoToJSON,
    WarehouseTransportMethodsDtoToJSONTyped,
} from './WarehouseTransportMethodsDto';
import type { DeliveryCalculationInternationalFeeRespVo } from './DeliveryCalculationInternationalFeeRespVo';
import {
    DeliveryCalculationInternationalFeeRespVoFromJSON,
    DeliveryCalculationInternationalFeeRespVoFromJSONTyped,
    DeliveryCalculationInternationalFeeRespVoToJSON,
    DeliveryCalculationInternationalFeeRespVoToJSONTyped,
} from './DeliveryCalculationInternationalFeeRespVo';
import type { DeliveryCalculationKrFeeRespVo } from './DeliveryCalculationKrFeeRespVo';
import {
    DeliveryCalculationKrFeeRespVoFromJSON,
    DeliveryCalculationKrFeeRespVoFromJSONTyped,
    DeliveryCalculationKrFeeRespVoToJSON,
    DeliveryCalculationKrFeeRespVoToJSONTyped,
} from './DeliveryCalculationKrFeeRespVo';

/**
 * 
 * @export
 * @interface DeliveryCalculationInitRespVo
 */
export interface DeliveryCalculationInitRespVo {
    /**
     * 仓库及其配置的运输方式
     * 仓库运输方式联动数据
     * @type {Array<WarehouseTransportMethodsDto>}
     * @memberof DeliveryCalculationInitRespVo
     */
    warehouseTransportMethods?: Array<WarehouseTransportMethodsDto>;
    /**
     * 国际运输会员等级运费
     * 国际运费联动数据
     * @type {Array<DeliveryCalculationInternationalFeeRespVo>}
     * @memberof DeliveryCalculationInitRespVo
     */
    internationalFees?: Array<DeliveryCalculationInternationalFeeRespVo>;
    /**
     * 韩国本土运输会员等级运费
     * 韩国运费联动数据
     * @type {Array<DeliveryCalculationKrFeeRespVo>}
     * @memberof DeliveryCalculationInitRespVo
     */
    krFees?: Array<DeliveryCalculationKrFeeRespVo>;
    /**
     * 运费配置使用的会员等级
     * 会员等级选项
     * @type {Array<DeliveryCalculationMemberGradeRespVo>}
     * @memberof DeliveryCalculationInitRespVo
     */
    memberGrades?: Array<DeliveryCalculationMemberGradeRespVo>;
    /**
     * 仓库与附加服务配置
     * 仓库附加服务联动数据
     * @type {Array<DeliveryCalculationAdditionalServiceRespVo>}
     * @memberof DeliveryCalculationInitRespVo
     */
    additionalServices?: Array<DeliveryCalculationAdditionalServiceRespVo>;
    /**
     * 中国当前启用汇率的适用汇率
     * 适用汇率，与代买费用测算口径一致
     * @type {number}
     * @memberof DeliveryCalculationInitRespVo
     */
    exchangeRate?: number;
}

/**
 * Check if a given object implements the DeliveryCalculationInitRespVo interface.
 */
export function instanceOfDeliveryCalculationInitRespVo(value: object): value is DeliveryCalculationInitRespVo {
    return true;
}

export function DeliveryCalculationInitRespVoFromJSON(json: any): DeliveryCalculationInitRespVo {
    return DeliveryCalculationInitRespVoFromJSONTyped(json, false);
}

export function DeliveryCalculationInitRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryCalculationInitRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseTransportMethods': json['warehouseTransportMethods'] == null ? undefined : ((json['warehouseTransportMethods'] as Array<any>).map(WarehouseTransportMethodsDtoFromJSON)),
        'internationalFees': json['internationalFees'] == null ? undefined : ((json['internationalFees'] as Array<any>).map(DeliveryCalculationInternationalFeeRespVoFromJSON)),
        'krFees': json['krFees'] == null ? undefined : ((json['krFees'] as Array<any>).map(DeliveryCalculationKrFeeRespVoFromJSON)),
        'memberGrades': json['memberGrades'] == null ? undefined : ((json['memberGrades'] as Array<any>).map(DeliveryCalculationMemberGradeRespVoFromJSON)),
        'additionalServices': json['additionalServices'] == null ? undefined : ((json['additionalServices'] as Array<any>).map(DeliveryCalculationAdditionalServiceRespVoFromJSON)),
        'exchangeRate': json['exchangeRate'] == null ? undefined : json['exchangeRate'],
    };
}

export function DeliveryCalculationInitRespVoToJSON(json: any): DeliveryCalculationInitRespVo {
    return DeliveryCalculationInitRespVoToJSONTyped(json, false);
}

export function DeliveryCalculationInitRespVoToJSONTyped(value?: DeliveryCalculationInitRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseTransportMethods': value['warehouseTransportMethods'] == null ? undefined : ((value['warehouseTransportMethods'] as Array<any>).map(WarehouseTransportMethodsDtoToJSON)),
        'internationalFees': value['internationalFees'] == null ? undefined : ((value['internationalFees'] as Array<any>).map(DeliveryCalculationInternationalFeeRespVoToJSON)),
        'krFees': value['krFees'] == null ? undefined : ((value['krFees'] as Array<any>).map(DeliveryCalculationKrFeeRespVoToJSON)),
        'memberGrades': value['memberGrades'] == null ? undefined : ((value['memberGrades'] as Array<any>).map(DeliveryCalculationMemberGradeRespVoToJSON)),
        'additionalServices': value['additionalServices'] == null ? undefined : ((value['additionalServices'] as Array<any>).map(DeliveryCalculationAdditionalServiceRespVoToJSON)),
        'exchangeRate': value['exchangeRate'],
    };
}

